import { configureStore } from '@reduxjs/toolkit'
import reducer from '../reducer'
import formReducer from '../formSlice'

const rootReducer = {
  ...reducer,
  form: formReducer
}

export const store = configureStore({
  reducer: rootReducer
})
